import React, { useState } from 'react'
import { InvoiceListItem } from '../../../../../lib/types/Invoice'
import { useInvoice } from '../../../../../services/api/invoices'
import { View } from './View'
import { notification } from 'antd'
import QRCode from 'qrcode'

type Props = {
  invoice: InvoiceListItem
}

export const Container: React.FunctionComponent<Props> = ({ invoice }) => {
  const [getInvoice, { isLoading }] = useInvoice(invoice.id)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [qrCode, setQrCode] = useState<string>()

  const onSubmit = () => {
    getInvoice({
      companyId: invoice.companyId,
    })
      .then(({ data: invoice }) => {
        setIsModalVisible(true)
        QRCode.toDataURL(invoice.qrCode).then((url: string) => {
          setQrCode(url)
        })
      })
      .catch(() => {
        notification.error({
          message: 'Возникли ошибки при генерации QR кода',
          duration: 3,
        })
      })
  }

  return (
    <View
      onSubmit={onSubmit}
      isLoading={isLoading}
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      qrCode={qrCode}
    />
  )
}
